import { z } from 'zod';

import i18n from '@/lib/i18n/i18n';
import { ContentItemCategory } from '@/api/v4/content-items.api';
import { URL_REGEX } from '@/regexes';

const { t } = i18n;

export const getContentItemValidationSchema = () =>
  z
    .object({
      title: z
        .string()
        .trim()
        .nonempty(t`default:fieldIsRequired`)
        .max(100),
      description: z
        .string()
        .trim()
        .nonempty(t`default:fieldIsRequired`)
        .max(300),
      longDescription: z.string().optional(),
      date: z.string().nonempty(t`default:required`),
      category: z
        .object({
          value: z.nativeEnum(ContentItemCategory),
          label: z.string().nonempty(),
        })
        .nullable()
        .refine(val => val !== null, {
          message: t`default:required`,
        }),
      contentUrl: z.string().refine(value => URL_REGEX.test(value), {
        message: i18n.t`settings:feedTab.articleForm.errors.invalidUrl`,
      }),
      tags: z
        .array(
          z.object({
            value: z.string(),
            label: z.string().nonempty(),
          }),
        )
        .max(3),
      file: z
        .custom<File | null>(val => val === null || val instanceof File)
        .nullable(),
      project: z
        .object({
          label: z.string().nonempty(),
          value: z.string(),
        })
        .nullable(),
    })
    .superRefine((data, ctx) => {
      if (
        data.category?.value === ContentItemCategory.materials &&
        data.project === null
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t`default:required`,
          path: ['project'],
        });
      }
    });

export type ContentItemFormInput = z.input<
  ReturnType<typeof getContentItemValidationSchema>
>;
export type ContentItemFormFields = z.output<
  ReturnType<typeof getContentItemValidationSchema>
>;
